import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class QuantidadePercentualContratacaoProdutoStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable detalhes;
    @observable produtoSelecionado;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        if(this.activeTab === '3') {
            this.toggle('1')
        }

        this.filtro = filtro;
        this.produtoSelecionado = null;
        this.detalhes = [];

        this.indicadorService.findQuantidadePercentualContratacaoProduto(filtro).then(response => {
            this.dados = response.data.map((produto) => ({
                id: produto.id,
                nome: produto.produto,
                "Quantidade": produto.quantidade,
                "Percentual": produto.percentual
            }));

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    detalharProduto = (produto) => {
        this.carregando = true;
        this.erro = null;
        this.toggle('3')

        const filtro = { ...this.filtro, produtos: [ produto.id ? produto.id : -1 ] };

        this.produtoSelecionado = produto.nome;

        this.indicadorService.findContratacaoProdutoCargo(filtro).then(response => {
            this.detalhes = response.data.map((cargo) => ({
                nome: cargo.cargo,
                "Quantidade": cargo.quantidade
            }));

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
